export enum PhotoArrayType {
  DEFAULT = 'DEFAULT',
  CAROUSEL = 'CAROUSEL',
  GALLERY = 'GALLERY',
  VIDEO = 'VIDEO',
  VIDEOEDIT = 'VIDEOEDIT',
}
